jQuery(document).ready(function ($) {
    var accordion_buttons = $(".accordion");
    accordion_buttons.on('click', function(e) {
        $(this).toggleClass("accordionactive");
        var panel = $(this).next();
        if ($(this).hasClass("accordionactive")) {
            panel.css('height',  panel.prop("scrollHeight") + "px");
        } else {
            panel.css('height', 0);
        }
    });
});
